<template>
    <div>
        <Collapse v-model="value" simple style="border:0">
            <Panel name="1" hide-arrow style="margin: 20px 0 0 0;border:0" >
                <FormTitle :titleText="$t('Skill_Information')"/><!-- 技能信息 -->
                <div slot="content" style="margin-top: 40px;">
                    <Table border :loading="loading" :columns="columns" :data="data"> 
                        <template slot-scope="{ row ,index }" slot="certificatenumber" >
                            <Select v-model="row.certificatenumber" v-if="row.be_local==1" clearable @on-change="targetItemChange(row, index, 'certificatenumber')"  transfer :disabled="id!=''||row.be_local=='0'">
                                <Option v-for="item in Language" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                            </Select>
                            <Input type="textarea" v-if="row.be_local==0" :autosize="true" v-model="row.certificatenumber" :disabled="id!=''||row.be_local=='0'"  @on-change="targetItemChange(row,index,'certificatenumber')" />
                        </template>
                        <template slot-scope="{ row ,index }" slot="skillscore" >
                            <Input type="textarea" :autosize="true" v-model="row.skillscore" :disabled="id!=''||row.be_local=='0'" @on-change="targetItemChange(row,index,'skillscore')" />
                        </template>
                        <template slot-scope="{ row ,index }" slot="degreecode" >
                            <Select v-model="row.degreecode" v-if="row.be_local==1" clearable @on-change="targetItemChange(row, index, 'degreecode')"  transfer :disabled="id!=''||row.be_local=='0'">
                                <Option v-for="item in skilllevel" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                            </Select>
                            <Input type="textarea" v-if="row.be_local==0" :autosize="true" v-model="row.degreecode" :disabled="id!=''||row.be_local=='0'" @on-change="targetItemChange(row,index,'degreecode')" />
                        </template>
                        <template slot-scope="{ row ,index }" slot="qualifydate" >
                            <DatePicker type="date" v-model="row.qualifydate" transfer :disabled="id!=''||row.be_local=='0'" @on-change="targetItemChange(row,index,'qualifydate')" />
                        </template>
                        <template slot-scope="{ row ,index }" slot="validityperiod" >
                            <Input type="textarea" :autosize="true" v-model="row.validityperiod" :disabled="id!=''||row.be_local=='0'" @on-change="targetItemChange(row,index,'validityperiod')" />
                        </template>
                        <template slot-scope="{ row ,index }" slot="expiredate" >
                            <DatePicker type="date" v-model="row.expiredate" transfer :disabled="id!=''||row.be_local=='0'" @on-change="targetItemChange(row,index,'expiredate')" />
                        </template>
                        <template slot="action" slot-scope="{ row, index }">
                            <Button type="warning" :disabled="id!=''||row.be_local=='0'" size="small"  style="margin-right: 8px" @click="save(row, index)"><!-- 保存 -->{{$t('Save')}}</Button>
                            <Button type="error" :disabled="id!=''||row.be_local=='0'" size="small"  @click="deleteItem(row, index)"><!-- 删除 -->{{$t('Delete')}}</Button>
                        </template>
                    </Table>
                    <div  v-if="id==''">
                        <span style="color: red;">{{$t('EmpFilesSkillComment')}}</span>
                    </div> 
                    <div style="margin:20px 0 0 0; display:flex; justify-content: flex-end;" >
                        <Page  :total="total" @on-change="pageChange"/>
                        <div style="margin-left:15px" v-if="id==''">
                            <Button  @click="addItem"><!-- 新增 -->{{$t('Add')}}</Button>
                            <!-- <Button  @click="save">保存</Button> -->
                        </div>
                    </div>
                </div>
            </Panel>
        </Collapse>
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            formItem:{},
            list:[],
            value:[1],
            date: new DateUtil(),
            loading:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[],
            id:'',
            serialnumber:'',
            Language:[],
            skilllevel:[]
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('Skill_language'),/* 语言技能 */
                    slot: "certificatenumber",
                    align: "center",
                    minWidth: 120,
                },
                // {
                //     title: this.$t('Skill_Score'),/* 技能分数 */
                //     slot: "skillscore",
                //     align: "center",
                //     minWidth: 120,
                // },
                {
                    title: this.$t('Skill_Rank'),/* 技能级别 */
                    slot: "degreecode",
                    align: "center",
                    minWidth: 120,
                },
                // {
                //     title: this.$t('Cerificate_Date'),/* 认证日期 */
                //     slot: "qualifydate",
                //     align: "center",
                //     minWidth: 120,
                // },{
                //     title: this.$t('Validity_Date'),/* 有效年数 */
                //     slot: "validityperiod",
                //     align: "center",
                //     minWidth: 120,
                // },{
                //     title: this.$t('Expire_Date'),/* 过期日 */
                //     slot: "expiredate",
                //     align: "center",
                //     minWidth: 120,
                // }
                {
                    title: this.$t('Action'),/* 操作 */
                    slot: "action",
                    align: "center",
                    minWidth: 120,
                },
            ]
        },
        lang(){
            return this.$store.getters.selectLangeData
        }
    },
    methods:{
        getData(val){
            this.getListData()
            this.loading=true
            val?this.serialnumber=val:this.serialnumber=JSON.parse(sessionStorage.getItem("userInfo")).serialnumber
            axios.post("/skillInformation/getSkillInformation", {...this.pageInfo,serialnumber:this.serialnumber}).then((res) => {
                this.loading=false
                if (res) {
                   this.data=res.data
                   this.total=parseInt(res.pageInfo.total)
                }
            })
        },
        getListData(){
            axios.post("/skillInformation/getSkillInformationLabel", {}).then((res) => {
                if (res) {
                   this.Language=res.Language
                   this.skilllevel=res.skilllevel
                }
            })
        },
        addItem(){
            this.data.push({
                certificatenumber:'',
                skillscore:'',
                degreecode:'',
                qualifydate:'',
                validityperiod:'',
                expiredate:'',
                serialnumber:this.serialnumber,
                be_local : 1
            })
        },
        save(item,index){
            axios.post("/skillInformation/insertSkillInformation",item).then((res) => {
                if (res) {
                    this.$Message.success(this.$t('Save_Successful'))
                    this.getData(this.serialnumber)
                }
            })
        },
        deleteItem(item,index){
            this.$Modal.confirm({
                title: this.$t('Are_you_sure_to_delete'),
                onOk: () => {
                    if(item.autoid){
                        axios.post("/skillInformation/deleteSkillInformation",{autoid:item.autoid,serialnumber:this.serialnumber}).then((res) => {
                            if (res) {
                                this.$Message.success('删除成功')
                                this.getData(this.serialnumber)
                            }
                        })
                    }else {
                        this.data.splice(index,1)
                    }
                    
                }
            })
        },
        targetItemChange(row,index,key){
            if(key=='qualifydate'){
                row.qualifydate=this.date.dateVal(row.qualifydate,"YYYY-MM-DD")
            }else if(key=='expiredate'){
                row.expiredate=this.date.dateVal(row.expiredate,"YYYY-MM-DD")
            }
            key && this.$set(this.data[index], key, row[`${key}`]);
        },
        pageChange(val){
            this.pageInfo.pageNo = val
        },
    }
}
</script>

<style lang="less" scoped>
.btnfooter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/components/SkillInformation.vue